<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 fees-limits">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>Fees and Limits</h2>
          <p>
            The information in this table summarises product features and is not
            intended<br />to replace
            <router-link v-bind:to="termsConditionsRoute"
              >Terms &amp; Conditions</router-link
            >
          </p>
          <FeesAndLimits />
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>

        <div class="spacer-60"></div>
      </div>

      <div class="col-md-4 promos">
        <Promotions />
      </div>
      <div class="col-md-4 promos promos2">
        <Promotions />
      </div>
    </div>
    <Cards />
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Cards from "./Cards.vue";
import Promotions from "./Promotions.vue";
import routes from "@/constants/routes";
import FeesAndLimits from "./FeesAndLimits.vue";
export default {
  components: {
    Cards,
    Promotions,
    FeesAndLimits
  },
  created() {
    this.termsConditionsRoute = routes.CONDITIONS;
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    }
  }
};
</script>
